import React, { useEffect } from 'react'
import Breadcrumbs from '@mui/material/Breadcrumbs';
import { Link } from 'react-router-dom'
import { MdNavigateNext } from 'react-icons/md'
import { Button, Grid, InputLabel, MenuItem, Select, Table, TableBody, TableCell, TableHead, TableRow, TextField, } from '@mui/material';
import Box from '@mui/material/Box';
import Pagination from '@mui/material/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import styled from "styled-components";
import { useStyles } from '../../constant/constant.js';
import { axiosRequest } from '../../utility/axios.js';
import { apiBaseUrl } from '../../constant/endpoint.js';
import { useState } from 'react';
import ViewContest from './view.js';
import { getDate, getSweetAlert } from '../../helper/index.js';
import { useNavigate } from 'react-router-dom';
import ConfirmedDialog from '../../components/dialog/confirmedDialog.js';
import moment from "moment/moment";
import Stack from '@mui/material/Stack';

export const PaymentOffersTable = ({ contestList, pagination, searchData}) => {
    const currDate = moment().format('YY/MM/DD HH:MM');
    const [contests, setContests] = useState(contestList);
    const [paginationData, setPaginationData] = useState(pagination);
    const [viewContestDialog, setViewContestDialog] = useState(false);
    const [selectContest, setSelectContest] = useState('');
    const [isConfirmDialog, setIsConfirmDialog] = useState(false);
    const classes = useStyles();
    const loginSlice = useSelector(state => state.loginSlice);
    const token = loginSlice.token;
    const navigate = useNavigate();

    const handleSearch = (page = 1, size = 20) => {
        let bodyData = { page: page, size: size };
        console.log("searchData",searchData);
        if(searchData && searchData.date_from && searchData.date_to) {
            bodyData = {...bodyData, ...searchData};
        }
        let searchUrl = `/paymentOffer/list`;
        getContestList(searchUrl, bodyData)
    }

    const getContestList = async (url, bodyData) => {

        const res = await axiosRequest("POST", url, token, bodyData);
        if (res?.status === "success") {
            setContests(res.data.paymentOffersList);
            setPaginationData(res.data.paginationData);
        }

    }

    const handleOpenDialog = (data) => {
        setViewContestDialog(!viewContestDialog);
        setSelectContest(data);
    }

    useEffect(() => {
        setContests(contestList);
        setPaginationData(pagination);
        // getContestList();
    }, [contestList])

    useEffect(() => {
        handleSearch(paginationData.currentPage);

    }, [paginationData.currentPage])


    const handleStatus = async() => {
        let url = `/paymentOffers/status?id=${selectContest._id}&status=${selectContest.data.status}`;
        const res = await axiosRequest("PUT", url, token, selectContest.data);
        if (res?.status === "success") {
            handleSearch(paginationData.currentPage)
            getSweetAlert("success", "Record Update SuccessFully") ;

        } else {
            getSweetAlert("error", "Failed To Update Record") ;
        }
        setIsConfirmDialog(false);
    }

    const handleConfirmation = async(id, key, value, label) => {
       
        setSelectContest({
            _id: id,
            data : {
                [key] : value
            },
            "label": label
        })
        setIsConfirmDialog(true);
    }

   const handleIsConfirmClose = () => {
        setIsConfirmDialog(false);
   }

   const handleRouteChange = (id, type) => {
    if(type == "view"){
        navigate(`/payment-offer/view/${id}`);
    } else if(type == "edit"){
        navigate(`/payment-offer/edit/${id}`);
    }
   }; 

    const handleChange = (event, value) => {
        setPaginationData({ ...paginationData, "currentPage": value });
    };

    return (
        <>
            <div >
                <div className='subHomeCard'>


                    <Box>
                        <Table className={classes.table} >
                            <TableHead>
                                <TableCell align="center">Id</TableCell>
                                <TableCell align="center">Code</TableCell>
                                <TableCell align="center">Max Cashback Amount</TableCell>
                                <TableCell align="center">Max Cashback Percent</TableCell>
                                <TableCell align="center">Usage Limit</TableCell>
                                {/* <TableCell align="center">Sequence</TableCell> */}
                                <TableCell align="center">Per User Limit</TableCell>
                                <TableCell align="center">Expiry Date</TableCell>
                                <TableCell align="center">Status</TableCell>
                                <TableCell align="center">Offer Status</TableCell>
                                <TableCell align="center">Actions</TableCell>
                            </TableHead>
                            <TableBody>
                                {
                                    contests?.map((data, index) =>
                                        <TableRow>
                                            <TableCell align="center">{data._id}</TableCell>
                                            <TableCell align="center">{data.coupon_code}</TableCell>
                                            <TableCell align="center">{data.max_cashback_amount}</TableCell>
                                            <TableCell align="center">{data.max_cashback_percent}</TableCell>
                                            <TableCell align="center">{data.usage_limit}</TableCell>
                                            {/* <TableCell align="center">{data.sequence}</TableCell> */}
                                            <TableCell align="center">{data.per_user_limit}</TableCell>
                                            <TableCell align="center">{getDate(data.expiry_date)}</TableCell>
                                            {/* <TableCell onClick={handleStatus}>{data.status ? <span style={{background:"green",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>Active</span> : <span style={{background:"red",padding:"5px",margin:"10px",color:"#fff",borderRadius:"5px"}}>Inactive</span>}</TableCell> */}
                                            <TableCell align="center" onClick={() => handleConfirmation(data._id, 'status', data.status ? 0 : 1, "status")} style={{cursor:"pointer"}}>
                                                {data.status === 1? (
                                                    <span style={{ background: "green", padding: "5px", margin: "10px", color: "#fff", borderRadius: "5px" }}>
                                                        Active
                                                    </span>
                                                ) : (
                                                    <span style={{ background: "red", padding: "5px", margin: "10px", color: "#fff", borderRadius: "5px" }}>
                                                        Inactive
                                                    </span>
                                                )}
                                            </TableCell>

                                            <TableCell align="center">{currDate > moment(data.expiry_date).format('YY/MM/DD HH:MM') ? "Expired" : "Activated"}</TableCell>

                                            <TableCell align="center">
                                            <Stack direction="column" spacing={1}>
                                                <Button variant={'contained'} size='small' onClick={() => handleRouteChange(data._id, "view")} >View</Button>
                                                <Button variant={'contained'} size='small' onClick={() => handleRouteChange(data._id, "edit")} >Edit</Button>
                                            </Stack>
                                            </TableCell>

                                        </TableRow>
                                    )
                                }
                            </TableBody>
                        </Table>

                    </Box>
                    <PaginationContainer>
                        <Pagination
                            count={paginationData.totalPage}
                            page={paginationData.currentPage}
                            onChange={handleChange}
                            color="primary"
                        />
                    </PaginationContainer>


                </div>
            </div>
            {viewContestDialog ? <ViewContest open={viewContestDialog} handleClose={handleOpenDialog} data={selectContest}></ViewContest> : ""}
            <ConfirmedDialog open ={isConfirmDialog} handleClose={handleIsConfirmClose} handleConfirmed={handleStatus} label={selectContest.label}></ConfirmedDialog>               
        </>
    )
}

export const PaginationContainer = styled.div`
display: flex;
justify-content: center;
margin: 16px 10px;
`

export default PaymentOffersTable